"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserClient = void 0;
const api_1 = require("../core/api");
const USER_AUTH_TOKEN = 'x-eusi-user-auth-token';
/**
 * Client that contains identity related operations
 */
class UserClient {
    constructor(config) {
        this.config = config;
        this.api = new api_1.ApiService(config);
    }
    /**
     * Fetch users by provided query
     * @param query @type Query
     */
    find(query) {
        const { api } = this;
        return api.get(["users"], query);
    }
    /**
     * Fetch single user by provided ide or key
     * @param idOrKey @type string
     */
    single(idOrKey) {
        const { api } = this;
        return api.get(["users", idOrKey]);
    }
    /**
     * Fetch user by user auth token
     * @param token @type string
     */
    current(token) {
        const { api } = this;
        const config = { headers: {} };
        config.headers[USER_AUTH_TOKEN] = token;
        return api.get(["users", "current"], null, config);
    }
    /**
     * Create new user
     * @param body @type User
     */
    create(body) {
        const { api } = this;
        return api.post(["users"], body);
    }
    /**
     * Change user's password
     * @param id @type String
     * @param body @type PasswordChange
     */
    changePassword(id, body) {
        const { api } = this;
        return api.put(["users", id, "password", "change"], body);
    }
    /**
     * Request a password change for user by providing email
     * @param body @type PasswordResetRequest
     */
    requestPasswordReset(body) {
        const { api } = this;
        return api.post(["users", "password", "request"], body);
    }
    /**
     * Set user's new password by providing token and new password
     * @param body @type PasswordReset
     */
    resetPassword(body) {
        const { api } = this;
        return api.post(["users", "password", "reset"], body);
    }
    /**
     * Update user's data
     * @param id @type string
     * @param body @type User
     */
    update(id, body) {
        const { api } = this;
        return api.put(["users", id], body);
    }
    /**
     * Delete user
     * @param id @type string
     */
    destroy(id) {
        const { api } = this;
        return api.delete(["users", id]);
    }
    /**
     * Attach user to specified role
     * @param userId @type string
     * @param roles List of role names to attach user to
     */
    attachUserToRoles(userId, roles = []) {
        const { api } = this;
        return api.post(["users", userId, "roles", "attach"], {
            roles
        });
    }
    /**
     * Detach user from specified role
     * @param userId @type string
     * @param roles List of role names to detach user from
     */
    detachUserFromRoles(userId, roles = []) {
        const { api } = this;
        return api.post(["users", userId, "roles", "detach"], {
            roles
        });
    }
}
exports.UserClient = UserClient;
//# sourceMappingURL=user.client.js.map